import { createAsyncThunk } from '@reduxjs/toolkit'
import { PropertyRequest } from '../../types/Property'
import api from '../../axios'

export interface AddPropertyRequest {
  request: PropertyRequest | FormData
}
export interface UpdatePropertyRequest {
  request: PropertyRequest | FormData
  id: string | number
}
export interface DeletePropertyRequest {
  id: string | number
}

export interface FetchPropertyRequest {
  id?: string | number
}

export const fetchProperties = createAsyncThunk(
  'api/properties/get',
  async () => {
    const response = await api.get('/api/properties')
    return response.data
  }
)

export const addProperty = createAsyncThunk(
  'api/properties/post',
  async ({ request}: AddPropertyRequest) => {
    const response = await api.post('/api/properties', request, {
      headers: {
        //"content-type": "multipart/form-data"
      },
    })
    return response.data
  }
)

export const fetchPropertyById = createAsyncThunk(
  'api/properties/get/id',
  async ({ id}: FetchPropertyRequest) => {
    const response = await api.get('/api/properties/' + id)
    return response.data
  }
)

export const updateProperty = createAsyncThunk(
  'api/properties/update',
  async ({ request, id }: UpdatePropertyRequest) => {
    const response = await api.put(
      '/api/properties/' + id,
      request,
      {
        headers: {
          // "content-type": "multipart/form-data"
        },
      }
    )
    return response.data
  }
)

export const deleteProperty = createAsyncThunk(
  'api/properties/delete',
  async ({ id }: DeletePropertyRequest) => {
    const response = await api.post('/api/Properties/DeleteProperty' + id, {})
    return response.data
  }
)

export const addPropertyRating = createAsyncThunk(
  'api/properties/ratings',
  async ({ id }: DeletePropertyRequest) => {
    const response = await api.delete('/api/properties/ra' + id)
    return response.data
  }
)
